import {Directive, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appAlphaNumSpecial]',
})
export class AlphaNumericSpecialDirective {

  @Input() appAlphaNumSpecial: boolean;

  constructor() {
  }

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    if (this.appAlphaNumSpecial) {
      const charCode = event.key;
      const alphaRegex = new RegExp(`^[a-zA-Z0-9äÄöÖüÜß .-/+]+$`);
      if (!alphaRegex.test(charCode)) {
        event.preventDefault();
      }
      return true;
    }
  }
}
